module.exports = __webpack_public_path__ + "static/media/twitter-logo-silhouette.92184111.svg";